
<div class="container rich-text-editor-container" (mousedown)="$event.stopPropagation()" (click)="$event.stopPropagation()">
	<div class="content">
		<div [formGroup]="edform">
			<div class="editor" (mousedown)="onEditorMousedown($event)" (mouseup)="onEditorMouseup($event)">
				<ngx-editor-menu [editor]="editor" [toolbar]="toolbar">
				</ngx-editor-menu>
				<ngx-editor [editor]="editor" formControlName="editorContent" >
				</ngx-editor>
			</div>
		</div>
</div>
</div>
